import script from "./OidoDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoDatePicker.vue?vue&type=script&setup=true&lang=js"

import "./OidoDatePicker.vue?vue&type=style&index=0&id=3a65be66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a65be66"]])

export default __exports__